import { ContentBlockType, type TaggedContentBlockDto } from '../services/contentService';

/** One learner step in a block tag: a single block, or blocks an admin merged. */
export interface TagBlockLesson {
  id: string;
  blocks: TaggedContentBlockDto[];
}

export function isTagBlockLessonComplete(lesson: TagBlockLesson): boolean {
  return lesson.blocks.length > 0 && lesson.blocks.every((block) => block.isPassedForTag === true);
}

/**
 * Walk tagged blocks in API order. An ungrouped block is its own lesson.
 * Blocks that share lessonGroupKey are one lesson, placed where the first member appears.
 */
export function buildTagBlockLessons(blocks: TaggedContentBlockDto[]): TagBlockLesson[] {
  const displayable = blocks.filter((block) => block.type !== ContentBlockType.PageSeparator);
  const seenGroups = new Set<number>();
  const lessons: TagBlockLesson[] = [];

  for (const block of displayable) {
    const groupKey = block.lessonGroupKey;
    if (groupKey == null) {
      lessons.push({ id: `block-${block.id}`, blocks: [block] });
      continue;
    }
    if (seenGroups.has(groupKey)) continue;
    seenGroups.add(groupKey);

    const members = displayable.filter((candidate) => candidate.lessonGroupKey === groupKey);
    if (members.length < 2) {
      lessons.push({ id: `block-${block.id}`, blocks: [block] });
      continue;
    }
    lessons.push({ id: `group-${groupKey}`, blocks: members });
  }

  return lessons;
}

export function findTagBlockLessonIndex(lessons: TagBlockLesson[], blockId: number | undefined): number {
  if (blockId == null) return -1;
  return lessons.findIndex((lesson) => lesson.blocks.some((block) => block.id === blockId));
}
